module.exports = __webpack_public_path__ + "static/media/joyce_chen.b7cc58bf.png";